<template>
    <div class="addAddress absolute">
        <div class="list">
            <div class="item acea-row row-between-wrapper">
                <!-- <div class="name">姓名</div> -->
                <input type="text" placeholder="请输入收货人性名" v-model="userAddress.real_name" required />
            </div>
            <div class="item acea-row row-between-wrapper">
                <!-- <div class="name">联系电话</div> -->
                <input type="text" placeholder="请输入收货人手机号码" v-model="userAddress.phone" required />
            </div>
            <div class="item acea-row row-between-wrapper">
                <!-- <div class="name">所在地区</div> -->
                <div class="picker acea-row row-between-wrapper select-value form-control">
                    <div class="address">
                        <div slot="right" @click.stop="show2 = true">
                            {{ model2 || "请选择省市区" }}
                        </div>
                        <CitySelect ref="cityselect" v-model="show2" :callback="result2" :items="district" :ready="ready" provance="" city="" area=""></CitySelect>
                    </div>
                    <!-- <div class="iconfont icon-dizhi font-color-red"></div> -->
                </div>
            </div>
            <div class="item acea-row row-between-wrapper">
                <!-- <div class="name">详细地址</div> -->
                <input type="text" placeholder="请输入详细地址" v-model="userAddress.detail" required />
            </div>
        </div>
        <div class="default acea-row row-middle">
            <div class="select-btn">
                <div class="checkbox-wrapper">
                    <label class="well-check">
                        <!-- <input
              type="checkbox"
              name=""
              value=""
              @click="ChangeIsDefault"
              :checked="userAddress.is_default ? true : false"
            /> -->
                        <span class="def">是否默认地址</span>
                    </label>
                </div>
            </div>
            <div class="set-default">
                <div class="set-default-item" @click="userAddress.is_default = 1">

                    <div class="text">是</div>
                    <img src="../../../assets/images/single_choose_icon_ed.png" v-if="userAddress.is_default == 1" alt="">
                    <div class="border1" v-else></div>
                </div>
                <div class="set-default-item" @click="userAddress.is_default = 0">

                    <div class="text">否</div>
                    <img src="../../../assets/images/single_choose_icon_ed.png" v-if="userAddress.is_default == 0" alt="">
                    <div class="border1" v-else></div>
                </div>
            </div>
        </div>
        <div></div>
        <div class="keepBnt bg-color-red" @click="submit">保存</div>
        <!-- <div class="wechatAddress" v-if="isWechat && !id" @click="getAddress">
            导入微信地址
        </div> -->
    </div>
</template>
<script type="text/babel">
import { CitySelect } from "vue-ydui/dist/lib.rem/cityselect";
import { getAddress, postAddress } from "@api/user";
import { getCity } from "@api/public";
import attrs, { required, chs_phone } from "@utils/validate";
import { validatorDefaultCatch } from "@utils/dialog";
import { openAddress } from "@libs/wechat";
import { isWeixin } from "@utils";

export default {
    components: {
        CitySelect,
    },
    data() {
        return {
            show2: false,
            model2: "",
            district: [],
            id: 0,
            userAddress: { is_default: 0 },
            address: {},
            isWechat: isWeixin(),
            ready: false,
        };
    },
    mounted: function () {
        let id = this.$route.params.id;
        this.id = id;
        document.title = !id ? "添加地址" : "修改地址";
        this.getUserAddress();
        this.getCityList();
    },
    methods: {
        getCityList: function () {
            let that = this;
            getCity()
                .then((res) => {
                    that.district = res.data;
                    that.ready = true;
                })
                .catch((err) => {
                    that.$dialog.error(err.msg);
                });
        },
        getUserAddress: function () {
            if (!this.id) return false;
            let that = this;
            getAddress(that.id)
                .then((res) => {
                    that.userAddress = res.data;
                    that.model2 =
                        res.data.province +
                        " " +
                        res.data.city +
                        " " +
                        res.data.district;
                    that.address.province = res.data.province;
                    that.address.city = res.data.city;
                    that.address.district = res.data.district;
                    that.address.city_id = res.data.city_id;
                })
                .catch((err) => {
                    that.$dialog.error(err.msg);
                });
        },
        getAddress() {
            openAddress().then((userInfo) => {
                this.$dialog.loading.open();
                postAddress({
                    id: this.id,
                    real_name: userInfo.userName,
                    phone: userInfo.telNumber,
                    address: {
                        province: userInfo.provinceName,
                        city: userInfo.cityName,
                        district: userInfo.countryName,
                        city_id:userInfo.city_id
                    },
                    detail: userInfo.detailInfo,
                    is_default: 1,
                    post_code: userInfo.postalCode,
                    type: 1,
                })
                    .then(() => {
                        this.$dialog.loading.close();
                        this.$dialog.toast({ mes: "添加成功" });
                        this.$router.go(-1);
                    })
                    .catch((err) => {
                        this.$dialog.loading.close();
                        this.$dialog.error(err.msg || "添加失败");
                    });
            });
        },
        async submit() {
            let name = this.userAddress.real_name,
                phone = this.userAddress.phone,
                model2 = this.model2,
                detail = this.userAddress.detail,
                isDefault = this.userAddress.is_default;
            try {
                await this.$validator({
                    name: [
                        required(required.message("姓名")),
                        attrs.range([2, 16], attrs.range.message("姓名")),
                    ],
                    phone: [
                        required(required.message("联系电话")),
                        chs_phone(chs_phone.message()),
                    ],
                    model2: [required("请选择地址")],
                    detail: [required(required.message("具体地址"))],
                }).validate({ name, phone, model2, detail });
            } catch (e) {
                return validatorDefaultCatch(e);
            }
            try {
                let that = this,
                    data = {
                        id: that.id,
                        real_name: name,
                        phone: phone,
                        address: JSON.stringify({
                            province: this.address.province,
                            city: this.address.city,
                            district: this.address.district,
                            city_id: this.address.city_id,
                        }),
                        detail: detail,
                        is_default: isDefault,
                        post_code: "",
                    };
                postAddress(data)
                    .then(function () {
                        if (that.id) that.$dialog.toast({ mes: "修改成功" });
                        else that.$dialog.toast({ mes: "添加成功" });
                        that.$router.go(-1);
                    })
                    .catch((err) => {
                        that.$dialog.error(err.msg);
                    });
            } catch (e) {
                this.$dialog.error(e.msg);
            }
        },
        ChangeIsDefault: function () {
            this.userAddress.is_default = !this.userAddress.is_default;
        },
        result2(ret) {
            console.log(ret);
            this.model2 =
                ret.itemName1 + " " + ret.itemName2 + " " + ret.itemName3;
            this.address.province = ret.itemName1;
            this.address.city = ret.itemName2;
            this.address.city_id = ret.itemValue2;
            this.address.district = ret.itemName3;
        },
    },
};
</script>
<style scoped>
.addAddress {
    margin: 0.36rem 0.42rem;
    box-shadow: 0px 2px 30px 0px rgba(157, 157, 157, 0.2);
    border-radius: 0.1rem;
    width: auto;
    background: #ffffff;
}
.addAddress .keepBnt {
    width: auto;
    margin: 1.5rem 0.26rem -0.45rem;
}
.addAddress .default {
    padding: 0 0.3rem;
    margin: 0 0.22rem 0;
    background: #f8f8f8;
    border-radius: 0.1rem;
    justify-content: space-between;
}
.addAddress .default .def {
    margin-left: 0;
}
.addAddress .list {
    padding: 0.4rem 0.22rem 0;
}
.addAddress .list .item {
    background: #f8f8f8;
    border-radius: 0.1rem;
    border-top: 0;
    margin-bottom: 0.2rem;
    font-size: 0.28rem;
    color: #999999;
}
.addAddress .list .item input {
    font-size: 0.28rem;
}
.set-default {
    flex: 1;
    justify-content: flex-end;
    display: flex;
    align-items: center;
}
.set-default .set-default-item {
    display: flex;
    align-items: center;
    margin-left: 0.25rem;
}
.set-default .set-default-item .text {
    font-size: 0.28rem;
    color: #333333;
    margin-right: 0.2rem;
}
.set-default .set-default-item .border1 {
    width: 0.32rem;
    height: 0.32rem;
    border: 1px solid #999999;
    border-radius: 100%;
}
.addAddress .list .item .address{
    flex: 1;
    width: auto;
}
.addAddress .list .item .picker{
    flex: 1;
    width: auto;
}
.set-default .set-default-item img {
    width: 0.32rem;
    object-fit: contain;
    height: 0.32rem;
}
.router {
    left: 0;
    right: 0;
}
</style>